export const SetLocalUserInfo = (userInfo) => localStorage.setItem('userInfo', JSON.stringify(userInfo))

export const GetLocalUserInfo = () => JSON.parse(localStorage.getItem('userInfo'))

export const DeleteLocalUserInfo = () => localStorage.removeItem('userInfo')
